import { useState } from "react";

import { DataContext } from "../../../Context/HelperOne";
import NavBar from "../nav_bar/Navbar";
import ChitDetailsList from "./ChitDetailsList";

const ChitDetails = () => {

    const [searchUi, setSearchUi] = useState(true)
    const [searchData, setSearchData] = useState(null)


    return (
        <div>
            <DataContext.Provider value={{ searchUi, setSearchUi, searchData, setSearchData }}>
                <NavBar
                    childrenPage={<ChitDetailsList />}
                    menuId={6}
                />
            </DataContext.Provider>
        </div>
    )
}

export default ChitDetails
